import { atom } from "recoil";

// NOTE 반복 모체 블록을 저장하는 상태
export const recurrenceOriginalBlockState = atom({
  key: "recurrenceOriginalBlockState",
  default: new Map(),
});
